import { useAuth } from "src/contexts/auth";

/**
 * Returns true if the currently authenticated Auth0 user has the executive
 * claim. This is the same gate used by `app-navigation.js` to show the
 * "Executive" section of the side nav.
 *
 * Kate is intentionally limited to executives because she has access to
 * cross-customer data via her tools.
 */
export function useExecutiveGate(): boolean {
  const { user } = useAuth();
  return !!(
    user &&
    (user as Record<string, string>)["https://elembio.io/roles"]?.includes(
      "Telemetry Executive",
    )
  );
}
